import { STRING } from "@constants";
import { InsuranceRead } from "@types";

const T = STRING.INSURANCE_DETAILS;

export function getInsuranceDetails(data?: InsuranceRead | null) {
  if (!data) return { sections: [] };

  const sections: any[] = [];

  sections.push({
    title: data.Provider ?? T.UNNAMED,
    icon: "pi-briefcase",
    fields: [
      {
        label: T.DESCRIPTION,
        value: data.Description,
        icon: "pi-align-left",
      },
      {
        label: T.AMOUNT,
        value: data.Amount != null ? `$${data.Amount.toFixed(2)}` : undefined,
        icon: "pi-dollar",
      },
      {
        label: T.COVERAGE,
        value:
          data.Coverage != null
            ? `$${data.Coverage.toLocaleString()}`
            : undefined,
        icon: "pi-shield",
      },
      {
        label: T.LOCATION_ID,
        value: data.LocationId,
        icon: "pi-map-marker",
      },
      {
        label: T.IDENTIFIER,
        value: data.Identifier,
        icon: "pi-hashtag",
      },
    ],
  });

  return { sections };
}
